import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = { class: "col-3" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "text-h6" }
const _hoisted_5 = { class: "text-body1" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "text-center fit flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_ManageBtn = _resolveComponent("ManageBtn")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, { class: "q-pa-md" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_img, {
            src: _ctx.preset.imageUrl
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.preset.label), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.preset.description), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_ManageBtn, {
              connection: _ctx.connection,
              color: "grey-5",
              size: "lg",
              round: "",
              unelevated: "",
              "no-caps": "",
              "onUpdate:connection": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:connection', $event)))
            }, null, 8, ["connection"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}